import { Typography, Grid, TextField, Box, useTheme } from '@mui/material';
import { SectionHeader } from './SectionHeader';
import { SignatureSection } from './SignatureSection';

interface ContractorCertificationProps {
  contractorInfo: {
    name: string;
    date: string;
    signature: string;
  };
  setContractorInfo: (info: { name: string; date: string; signature: string }) => void;
}

export const ContractorCertification: React.FC<ContractorCertificationProps> = ({
  contractorInfo,
  setContractorInfo,
}) => {
  const theme = useTheme();

  return (
    <>
      <SectionHeader>
        <Typography variant="subtitle1">Contractor Certification</Typography>
      </SectionHeader>
      <SignatureSection>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Name:
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={contractorInfo.name}
              onChange={e => setContractorInfo({ ...contractorInfo, name: e.target.value })}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Date:
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="date"
              value={contractorInfo.date}
              onChange={e => setContractorInfo({ ...contractorInfo, date: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Contractor Signature:
            </Typography>
            <Box
              sx={{ borderBottom: `1px solid ${theme.palette.divider}`, height: '40px', mb: 1 }}
            />
            <Typography variant="caption" sx={{ fontSize: '10px', fontStyle: 'italic' }}>
              I hereby certify that this quotation is complete and accurate based on the information
              provided
            </Typography>
          </Grid>
        </Grid>
      </SignatureSection>
    </>
  );
};
